module.exports = __webpack_public_path__ + "static/media/code-construction-logo.50c7764f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/billing-icons/code-construction-logo.png
// module id = 1269
// module chunks = 17